module.exports = __webpack_public_path__ + "static/media/conference.b59672fe.jpg";